export type TrendingEntry = {
    href: string
    testid: string
    aria: string
    icon: string
    label: string
}

export const TRENDING: TrendingEntry[] = [
    {
        href: '/nfl',
        testid: 'nfl-football',
        aria: 'football',
        icon: '🏈',
        label: 'NFL',
    },
    {
        href: '/mlb-baseball',
        testid: 'mlb-baseball',
        aria: 'baseball',
        icon: '⚾',
        label: 'MLB',
    },
    {
        href: '/taylor-swift-tickets/performer/12245',
        testid: 'taylor-swift',
        aria: 'microphone',
        icon: '🎤',
        label: 'Taylor Swift',
    },
    {
        href: '/rolling-stones-tickets/performer/738',
        testid: 'rolling-stones',
        aria: 'microphone',
        icon: '🎤',
        label: 'Rolling Stones',
    },
    {
        href: '/hamilton-tickets--theater-musical/performer/40710',
        testid: 'hamilton',
        aria: 'drama',
        icon: '🎭',
        label: 'Hamilton',
    },
    {
        href: '/olivia-rodrigo-tickets/performer/130861',
        testid: 'olivia-rodrigo',
        aria: 'microphone',
        icon: '🎤',
        label: 'Olivia Rodrigo',
    },
    {
        href: '/nba-playoff-tickets--sports-nba-basketball/custom/171',
        testid: 'nba-basketball-playoffs',
        aria: 'basketball',
        icon: '🏀',
        label: 'NBA Playoffs',
    },
]

export const FIRST_SET_LENGTH = 6
